export const geostruktura = {
  geotree: {
    Country: {
      name: "Wyspy Kanaryjskie",
      locID: "CIL000001",
      url: "/kanary.xml",
      Region: [
        {
          name: "Kanary: wycieczki objazdowe",
          locID: "CIL100000",
          url: "/kanary-wycieczki-objazdowe.xml"
        },
        {
          name: "Kanary: rejsy morskie",
          locID: "CIL200000",
          url: "/kanary-rejsy-morskie.xml"
        },
        {
          name: "Gran Canaria",
          locID: "CIL000095",
          url: "/gran-canaria.xml",
          Miniregion: [
            {
              name: "Las Palmas",
              locID: "CIL000357",
              url: "/wschodnia-gran-canaria.xml",
              Areatown: [
                {
                  name: "Las Palmas de Gran Canaria",
                  locID: "CIL000149",
                  url: "/las-palmas-gran-canaria.xml"
                },
                {
                  name: "Krater Caldera de Bandama",
                  locID: "CIL000116",
                  url: "/gran-canaria-caldera-de-bandama.xml"
                },
                {
                  name: "Telde",
                  locID: "CIL000330",
                  url: "/gran-canaria-telde.xml"
                },
                {
                  name: "Aguimes",
                  locID: "CIL000006",
                  url: "/gran-canaria-aguimes.xml"
                },
                {
                  name: "Wąwóz Guayadeque",
                  locID: "CIL000354",
                  url: "/gran-canaria-wawoz-guayadeque.xml"
                }
              ]
            },
            {
              name: "Ok. Maspalomas",
              locID: "CIL000202",
              url: "/poludniowa-gran-canaria.xml",
              Areatown: [
                {
                  name: "San Bartolome de Tirajana",
                  locID: "CIL000281",
                  url: "/gran-canaria-san-bartolome-de-tirajana.xml"
                },
                {
                  name: "Mundo Aborigen",
                  locID: "CIL000187",
                  url: "/gran-canaria-mundo-aborigen-guanczo.xml"
                },
                {
                  name: "Caleta",
                  locID: "CIL000034",
                  url: "/gran-canaria-caleta.xml"
                },
                {
                  name: "Sioux City",
                  locID: "CIL000308",
                  url: "/gran-canaria-sioux-city.xml"
                },
                {
                  name: "San Augustin",
                  locID: "CIL000280",
                  url: "/gran-canaria-san-augustin.xml",
                  Place: [
                    {
                      name: "Playa de San Agustin",
                      locID: "CIL000223",
                      url: "/gran-canaria-playa-de-san-agustin.xml"
                    },
                    {
                      name: "Playa de las Burras",
                      locID: "CIL000364",
                      url: "/gran-canaria-playa-de-las-burras.xml"
                    }
                  ]
                },
                {
                  name: "Playa del Ingles",
                  locID: "CIL000234",
                  url: "/gran-canaria-playa-del-ingles.xml"
                },
                {
                  name: "Maspalomas",
                  locID: "CIL000170",
                  url: "/gran-canaria-maspalomas.xml"
                },
                {
                  name: "Rezerwat Przyrody Pilancones",
                  locID: "CIL000275",
                  url: "/gran-canaria-rezerwat-przyrody-pilancones.xml"
                },
                {
                  name: "Arguineguin",
                  locID: "CIL000012",
                  url: "/gran-canaria-arguineguin.xml"
                },
                {
                  name: "Patalavaca",
                  locID: "CIL000201",
                  url: "/gran-canaria-patalavaca.xml"
                },
                {
                  name: "Puerto Rico",
                  locID: "CIL000262",
                  url: "/gran-canaria-puerto-rico.xml"
                },
                {
                  name: "Playa de los Amadores",
                  locID: "CIL000219",
                  url: "/gran-canaria-playa-de-los-amadores.xml"
                },
                {
                  name: "Taurito",
                  locID: "CIL000324",
                  url: "/gran-canaria-taurito.xml",
                  Place: [
                    {
                      name: "Playa Taurito",
                      locID: "CIL000240",
                      url: "/gran-canaria-playa-taurito.xml"
                    }
                  ]
                },
                {
                  name: "Playa del Cura",
                  locID: "CIL000233",
                  url: "/gran-canaria-playa-del-cura.xml"
                },
                {
                  name: "Puerto de Mogan",
                  locID: "CIL000258",
                  url: "/gran-canaria-puerto-de-mogan.xml"
                }
              ]
            },
            {
              name: "Region Płn.-Zach.",
              locID: "CIL000247",
              url: "/zachodnia-gran-canaria.xml",
              Areatown: [
                {
                  name: "Galdar",
                  locID: "CIL000090",
                  url: "/gran-canaria-galdar.xml"
                },
                {
                  name: "Santa Maria de Guia",
                  locID: "CIL000303",
                  url: "/gran-canaria-santa-maria-de-guia.xml"
                },
                {
                  name: "Arucas",
                  locID: "CIL000021",
                  url: "/gran-canaria-arucas.xml"
                }
              ]
            },
            {
              name: "Region Centralny",
              locID: "CIL000310",
              url: "/centralna-gran-canaria.xml",
              Areatown: [
                {
                  name: "Roque Nublo (Skała Mgieł)",
                  locID: "CIL000277",
                  url: "/gran-canaria-roque-nublo.xml"
                }
              ]
            }
          ]
        },
        {
          name: "Teneryfa",
          locID: "CIL000332",
          url: "/teneryfa.xml",
          Miniregion: [
            {
              name: "Ok. Santa Cruz",
              locID: "CIL000356",
              url: "/wschodnia-teneryfa.xml",
              Areatown: [
                {
                  name: "La Laguna",
                  locID: "CIL000131",
                  url: "/teneryfa-la-laguna.xml"
                },
                {
                  name: "Santa Cruz",
                  locID: "CIL000301",
                  url: "/teneryfa-santa-cruz-de-tenerife.xml"
                },
                {
                  name: "Las Caletillas",
                  locID: "CIL000142",
                  url: "/teneryfa-las-caletillas.xml"
                },
                {
                  name: "Guimar",
                  locID: "CIL000101",
                  url: "/teneryfa-guimar.xml"
                }
              ]
            },
            {
              name: "Ok. Costa Adeje",
              locID: "CIL000248",
              url: "/teneryfa-las-americas-costa-adeje.xml",
              Areatown: [
                {
                  name: "El Médano",
                  locID: "CIL000070",
                  url: "/teneryfa-el-medano.xml"
                },
                {
                  name: "Los Abrigos",
                  locID: "CIL000154",
                  url: "/teneryfa-los-abrigos.xml"
                },
                {
                  name: "San Miguel de Abona",
                  locID: "CIL000295",
                  url: "/teneryfa-san-miguel-de-abona.xml",
                  Place: {
                    name: "Golf de Sur",
                    locID: "CIL000092",
                    url: "/teneryfa-golf-de-sur.xml"
                  }
                },
                {
                  name: "Las Galletas",
                  locID: "CIL000147",
                  url: "/teneryfa-las-galletas.xml"
                },
                {
                  name: "Los Cristianos",
                  locID: "CIL000159",
                  url: "/teneryfa-los-cristianos.xml"
                },
                {
                  name: "Playa de las Americas",
                  locID: "CIL000216",
                  url: "/teneryfa-playa-de-las-americas.xml"
                },
                {
                  name: "Costa Adeje",
                  locID: "CIL000053",
                  url: "/teneryfa-costa-adeje.xml",
                  Place: [
                    {
                      name: "Plaża Playa Fanabe",
                      locID: "CIL000245",
                      url: "/teneryfa-plaza-playa-fanabe.xml"
                    },
                    {
                      name: "La Caleta",
                      locID: "CIL000118",
                      url: "/teneryfa-la-caleta.xml"
                    }
                  ]
                },
                {
                  name: "Adeje",
                  locID: "CIL000003",
                  url: "/teneryfa-adeje.xml"
                },
                {
                  name: "Playa Paraiso",
                  locID: "CIL000239",
                  url: "/teneryfa-playa-paraiso.xml"
                },
                {
                  name: "Callao Salvaje",
                  locID: "CIL000036",
                  url: "/teneryfa-callao-salvaje.xml"
                },
                {
                  name: "Guia de Isora",
                  locID: "CIL000100",
                  url: "/teneryfa-guia-de-isora.xml"
                }
              ]
            },
            {
              name: "Isla Baja",
              locID: "CIL000107",
              url: "/zachodnia-teneryfa.xml",
              Areatown: [
                {
                  name: "Puerto de Santiago",
                  locID: "CIL000259",
                  url: "/teneryfa-puerto-de-santiago.xml"
                },
                {
                  name: "Los Gigantes",
                  locID: "CIL000160",
                  url: "/teneryfa-los-gigantes.xml",
                  Place: {
                    name: "Playa de la Arena",
                    locID: "CIL000212",
                    url: "/teneryfa-playa-de-la-arena.xml"
                  }
                },
                {
                  name: "Garachico",
                  locID: "CIL000091",
                  url: "/teneryfa-garachico.xml"
                }
              ]
            },
            {
              name: "Ok. Puerto de la Cruz",
              locID: "CIL000255",
              url: "/teneryfa-puerto-de-la-cruz-teide.xml",
              Areatown: [
                {
                  name: "Puerto de la Cruz",
                  locID: "CIL000254",
                  url: "/teneryfa-puerto-de-la-cruz.xml",
                  Place: [
                    {
                      name: "Ogród Botaniczny (Jardin Botanico)",
                      locID: "CIL000191",
                      url: "/teneryfa-ogrod-botaniczny.xml"
                    },
                    {
                      name: "Ogród Różany (La Rosaleda)",
                      locID: "CIL000192",
                      url: "/teneryfa-la-rosaleda.xml"
                    }
                  ]
                },
                {
                  name: "Park Narodowy Teide",
                  locID: "CIL000197",
                  url: "/teneryfa-park-narodowy-teide.xml"
                }
              ]
            }
          ]
        },
        {
          name: "Fuerteventura",
          locID: "CIL000088",
          url: "/fuerteventura.xml",
          Miniregion: [
            {
              name: "Ok. Corralejo",
              locID: "CIL000089",
              url: "/polnocna-fuerteventura.xml",
              Areatown: [
                {
                  name: "Corralejo",
                  locID: "CIL000052",
                  url: "/fuerteventura-corralejo.xml"
                },
                {
                  name: "Costa Antigua",
                  locID: "CIL000374",
                  url: "/fuerteventura-costa-antigua.xml"
                },
                {
                  name: "Caleta de Fuste",
                  locID: "CIL000035",
                  url: "/fuerteventura-caleta-de-fuste.xml"
                },
                {
                  name: "Cotillo",
                  locID: "CIL000376",
                  url: "/fuerteventura-cotillo.xml"
                }
              ]
            },
            {
              name: "Płw. Jandia",
              locID: "CIL000366",
              url: "/poludniowa-fuerteventura.xml",
              Areatown: [
                {
                  name: "Tarajalejo",
                  locID: "CIL000321",
                  url: "/fuerteventura-tarajalejo.xml"
                },
                {
                  name: "Półwysep Jandia",
                  locID: "CIL000250",
                  url: "/fuerteventura-jandia.xml",
                  Place: [
                    {
                      name: "Costa Calma",
                      locID: "CIL000054",
                      url: "/fuerteventura-costa-calma.xml"
                    },
                    {
                      name: "Playa de Esquinzo",
                      locID: "CIL000211",
                      url: "/fuerteventura-playa-de-esquinzo.xml"
                    },
                    {
                      name: "Jandia Playa",
                      locID: "CIL000109",
                      url: "/fuerteventura-jandia-playa.xml"
                    },
                    {
                      name: "Playa de Butihondo",
                      locID: "CIL000210",
                      url: "/fuerteventura-playa-de-butihondo.xml"
                    }
                  ]
                },
                {
                  name: "Morro Jable",
                  locID: "CIL000185",
                  url: "/fuerteventura-morro-jable.xml"
                }
              ]
            }
          ]
        },
        {
          name: "Lanzarote",
          locID: "CIL000138",
          url: "/archipelag-lanzarote.xml",
          Miniregion: [
            {
              name: "W-pa Lanzarote",
              locID: "CIL000367",
              url: "/wyspa-lanzarote.xml",
              Areatown: [
                {
                  name: "Playa Blanca",
                  locID: "CIL000207",
                  url: "/lanzarote-playa-blanca.xml"
                },
                {
                  name: "Puerto Calero",
                  locID: "CIL000365",
                  url: "/lanzarote-puerto-calero.xml"
                },
                {
                  name: "Arrecife",
                  locID: "CIL000018",
                  url: "/lanzarote-arrecife.xml"
                },
                {
                  name: "Puerto del Carmen",
                  locID: "CIL000260",
                  url: "/lanzarote-puerto-del-carmen.xml"
                },
                {
                  name: "Playa de los Pocillos",
                  locID: "CIL000220",
                  url: "/lanzarote-playa-de-los-pocillos.xml"
                },
                {
                  name: "Costa Teguise",
                  locID: "CIL000056",
                  url: "/lanzarote-costa-teguise.xml"
                }
              ]
            },
            {
              name: "Graciosa i Alegranza",
              locID: "CIL000368",
              url: "/graciosa-alegranza.xml"
            }
          ]
        },
        {
          name: "La Gomera, La Palma i El Hierro",
          locID: "CIL000093",
          url: "/gomera-palma-hierro.xml",
          Miniregion: [
            {
              name: "La Palma",
              locID: "CIL000134",
              url: "/wyspa-la-palma.xml",
              Areatown: [
                {
                  name: "Santa Cruz de la Palma",
                  locID: "CIL000300",
                  url: "/santa-cruz-de-la-palma.xml"
                },
                {
                  name: "Los Cancajos",
                  locID: "CIL000158",
                  url: "/la-palma-los-cancajos.xml"
                },
                {
                  name: "Park Nar. Caldera de Taburiente",
                  locID: "CIL000377",
                  url: "/la-palma-park-nar-caldera-de-taburiente.xml"
                }
              ]
            },
            {
              name: "La Gomera",
              locID: "CIL000127",
              url: "/wyspa-la-gomera.xml",
              Areatown: [
                {
                  name: "San Sebastian de la Gomera",
                  locID: "CIL000297",
                  url: "/san-sebastian-de-la-gomera.xml"
                },
                {
                  name: "Alajeró",
                  locID: "CIL000380",
                  url: "/wyspa-la-gomera-alajero.xml"
                },
                {
                  name: "Playa de Santiago",
                  locID: "CIL000371",
                  url: "/la-gomera-playa-de-santiago.xml"
                },
                {
                  name: "Park Narodowy Garajonay",
                  locID: "CIL000139",
                  url: "/la-gomera-park-narodowy-garajonay.xml"
                },
                {
                  name: "Valle Gran Rey",
                  locID: "CIL000378",
                  url: "/la-gomera-valle-gran-rey.xml"
                }
              ]
            },
            {
              name: "El Hierro",
              locID: "CIL000067",
              url: "/wyspa-el-hierro.xml",
              Areatown: [
                {
                  name: "Valverde",
                  locID: "CIL000346",
                  url: "/el-hierro-valverde.xml"
                },
                {
                  name: "Puerto de la Estaca",
                  locID: "CIL000375",
                  url: "/el-hierro-puerto-de-la-estaca.xml"
                },
                {
                  name: "La Restinga",
                  locID: "CIL000372",
                  url: "/el-hierro-la-restinga.xml"
                },
                {
                  name: "Cruz de los Reyes",
                  locID: "CIL000403",
                  url: "/el-hierro-cruz-de-los-reyes.xml"
                },
                {
                  name: "Pozo de la Salud",
                  locID: "CIL000409",
                  url: "/el-hierro-pozo-de-la-salud.xml"
                },
                {
                  name: "Las Puntas",
                  locID: "CIL000416",
                  url: "/el-hierro-las-puntas.xml"
                },
                {
                  name: "Poblado de Guinea",
                  locID: "CIL000419",
                  url: "/el-hierro-poblado-de-guinea.xml"
                },
                {
                  name: "Punta de Orchilla",
                  locID: "CIL000421",
                  url: "/el-hierro-punta-de-orchilla.xml"
                },
                {
                  name: "La Frontera",
                  locID: "CIL000422",
                  url: "/el-hierro-la-frontera.xml"
                }
              ]
            }
          ]
        }
      ]
    }
  }
};
